import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { ButtonColor, ButtonSize } from '@freelancer/ui/button';
import { HeadingColor, HeadingType } from '@freelancer/ui/heading';
import { IconColor, IconSize } from '@freelancer/ui/icon';
import { FontColor, TextSize } from '@freelancer/ui/text';
import { ModalColor } from './modal-color';

@Component({
  selector: 'fl-modal-error',
  template: `
    <div
      class="ModalError"
      [attr.data-edge-to-edge]="edgeToEdge"
    >
      <fl-heading
        i18n="Modal load error title"
        [color]="
          color === ModalColor.LIGHT
            ? HeadingColor.FOREGROUND
            : HeadingColor.LIGHT
        "
        [headingType]="HeadingType.H3"
        [size]="TextSize.MID"
        [flMarginBottom]="'mid'"
      >
        Aw, snap!
      </fl-heading>

      <fl-text
        i18n="Modal load error description"
        [color]="
          color === ModalColor.LIGHT ? FontColor.FOREGROUND : FontColor.LIGHT
        "
        [flMarginBottom]="'small'"
      >
        Something went wrong while fetching the content. Please check your
        Internet connectivity and then retry.
      </fl-text>

      <div [flMarginBottom]="'mid'">
        <fl-text
          [color]="
            color === ModalColor.LIGHT ? FontColor.FOREGROUND : FontColor.LIGHT
          "
          [flMarginBottom]="'xxsmall'"
        >
          <fl-button (click)="toggleError()">
            <ng-container
              *ngIf="!isErrorDisplayed"
              i18n="Modal load error details show more link"
            >
              Show more information
            </ng-container>
            <ng-container
              *ngIf="isErrorDisplayed"
              i18n="Modal load error details hide more link"
            >
              Hide more information
            </ng-container>
            <fl-icon
              class="ModalError-icon"
              [class.IsActive]="isErrorDisplayed"
              [color]="
                color === ModalColor.LIGHT
                  ? IconColor.FOREGROUND
                  : IconColor.LIGHT
              "
              [name]="'ui-chevron-down'"
              [size]="IconSize.SMALL"
              (click)="toggleError()"
            ></fl-icon>
          </fl-button>
        </fl-text>

        <p
          class="ModalError-details"
          *ngIf="isErrorDisplayed"
        >
          {{ errorMessage }}
        </p>
      </div>

      <div class="ModalError-actions">
        <fl-button
          class="ModalError-retryBtn"
          i18n="Modal load error retry button"
          [color]="ButtonColor.SECONDARY"
          [size]="ButtonSize.SMALL"
          (click)="handleRetryClick()"
        >
          Retry
        </fl-button>
      </div>
    </div>
  `,
  styleUrls: ['./modal-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalErrorComponent {
  ButtonColor = ButtonColor;
  ButtonSize = ButtonSize;
  FontColor = FontColor;
  HeadingColor = HeadingColor;
  TextSize = TextSize;
  HeadingType = HeadingType;
  IconColor = IconColor;
  IconSize = IconSize;
  ModalColor = ModalColor;

  @Input() color = ModalColor.LIGHT;
  @Input() edgeToEdge = false;
  @Input() errorMessage: string;

  @Output() retry = new EventEmitter<void>();

  isErrorDisplayed = false;

  handleRetryClick(): void {
    this.retry.emit();
  }

  toggleError(): void {
    this.isErrorDisplayed = !this.isErrorDisplayed;
  }
}
